
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter site details:</p>
      </div>
    </div>
  </div>
  <form #siteForm="ngForm">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row justify-content-md-center">
          <div class="col-md-12 row">
            <div class="form-group col-lg-6">
              <label>Site Name</label>
              <div class="input-group border-bottom"><span class="text-secondary pl-2">{{site.name}}&nbsp;</span></div>
            </div>
            <div class="form-group col-lg-6">
              <label for="locationName">Location Name</label>
              <input class="form-control" id="locationName" type="text" [(ngModel)]="site.friendlyName" name="locationName" maxlength="80">
            </div>
          </div>
          <div class="col-md-12 row">
            <div class="form-group col-lg-6">
              <label>Business Partner ID</label>
              <div class="input-group border-bottom" style="height: calc(2.25rem + 2px);"><span class="text-secondary pl-2" style="position: absolute; bottom: 0">{{site.businessPartnerId}}&nbsp;</span></div>
            </div>
            <div class="form-group col-lg-6">
              <label for="siteCode">Site Code</label>
              <input class="form-control" id="siteCode" type="text" [(ngModel)]="site.siteCode" name="siteCode" maxlength="40">
            </div>
            <div class="form-group col-lg-6" *ngIf="site.siteNameStructure">
              <div class="inline-block">
                <label>Site Name Structure</label>
              </div>
              <div class="inline-block">
                <input class="form-control" id="siteNameStructure" type="text" [(ngModel)]="site.siteNameStructure" name="siteNameStructure" required [disabled]="!canEditNStr" maxlength="100">
              </div>
            </div>
          </div>
          <div class="col-md-12 row">
            <div class="form-group form-date col-lg-6" style="padding-top: 32px;">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label>Customer Requested Delivery</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Estimated Start Date" helpString="The estimated date that deployment deliverables will begin for this site"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="customerRequestedDevDatePicker" [(ngModel)]="site.customerRequestedDev" [value]="site.customerRequestedDev" showInputOnly="customerRequestedDev" name="customerRequestedDevDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-6">
              <label for="areaGroup">Area - Group</label>
              <select class="form-control" id="areaGroup" name="areaGroup" [(ngModel)]="site.defaultAreaGroup">
                <option [ngValue]="null"></option>
                <option *ngFor="let i of groupOptions" [ngValue]="i.id">{{ i.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-12 row">
            <div class="form-group col-md-6">
              <div class="col-md-12 pl-0">
                <label class="col-md-6 text-muted font-weight-lighter font-italic pl-0">Actual Delivery</label>
                <input class="col-md-6 muted-input text-muted font-weight-lighter font-italic" type="text" disabled [value]="site.startDate">
              </div>
              <div class="col-md-12 pl-0" style="margin-top: 0.65rem !important;">
                <label class="col-md-6 text-muted font-weight-lighter font-italic pl-0">Actual Installation</label>
                <input class="col-md-6 muted-input text-muted font-weight-lighter font-italic" type="text" disabled [value]="site.installDate">
              </div>
            </div>
            <div class="form-group col-lg-6">
              <div class="inline-block">
                <label for="sourceName">Source Name</label>
              </div>
              <div class="input-group">
                <input class="form-control" id="sourceName" [(ngModel)]="site.sourceName" name="sourceName" type="text" maxlength="60">
              </div>
            </div>
          </div>
          <div class="col-md-12 row">
            <div class="form-group col-md-6 inline-block">
              <label>Portico Data</label> 
              <div class="col-12 form-control" *ngIf="site.cdfs.length" style="height: auto !important;">
                <label class="font-italic m-0" *ngFor="let cdf of site.cdfs">{{ cdf.id }} ({{ cdf.system }})
                  <p class="m-0" *ngFor="let building of cdf.buildings">{{ building }}</p>
                </label>
              </div>
              <div class="form-group col-md-12 inline-block pl-0"><a class="btn btn-outline-primary" id="addPorticoData" href="javascript:void(0)" [ngClass]="{&quot;mt-2&quot;: site.cdfs.length}" (click)="editCdf(site.cdfs[0])">{{site.cdfs.length ? 'Edit' : 'Add' }} Portico Data</a></div>
            </div>
            <div class="form-group col-lg-6">
              <div class="inline-block">
                <label for="sourceDocumentationLink">Source Documentation Link</label>
              </div>
              <div class="input-group">
                <input class="form-control" id="sourceDocumentationLink" [(ngModel)]="site.sourceDocumentationLink" name="sourceDocumentationLink" type="text" maxlength="2000">
              </div>
            </div>
          </div>
          <div class="col-md-12 row" *ngIf="enableMultipleCA">
            <div class="form-group col-lg-6"></div>
            <div class="form-group col-lg-6">
              <div class="inline-block">
                <label for="contractAccount">Contract Account</label>
              </div>
              <div class="input-group">
                <select class="form-control" [(ngModel)]="site.contractAccountId" [id]="contractAcc.identifier" [name]="contractAcc.identifier" autoLinkToLabel [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="null"></option>
                  <option *ngFor="let i of contractAccounts" [ngValue]="i.id">{{ i.name }} - {{ i.id }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-12 row">
            <div class="form-group col-lg-6"></div>
            <div class="form-group col-lg-6">
              <div class="inline-block mt-1">
                <input class="form-check-input mr-1 ml-0" id="poCheck" style="position: relative;" type="checkbox" [name]="&quot;poCheck&quot;" [(ngModel)]="site.partnerPurchaseOrders" autoLinkToLabel.bold>
                <label class="bold form-check-label">Install Partner PO</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-10">
        <div class="row card-block mt-3 p-0 pt-4 pb-4" *ngIf="!loading &amp;&amp; settableAddresses &amp;&amp; settableAddresses.length">
          <div class="col">
            <div class="row">
              <div class="col-sm-12">
                <div class="col-sm-11">
                  <h4>{{ addressesInfo.physicalAddress.humanReadableTitle }}</h4>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="settableAddresses &amp;&amp; settableAddresses.length">
              <div class="col-sm-12">
                <div class="col-sm-12">
                  <select class="form-control" *ngIf="!addressesInfo.physicalAddress.readOnly" [(ngModel)]="site.physicalAddressId" [name]="site.physicalAddressId" autoLinkToLabel (change)="makeAddressesConsistentWithFlagsHelper()">
                    <option *ngFor="let addr of settableAddresses" [ngValue]="addr.id">{{ addr.itsmName }}</option>
                  </select>
                  <input class="form-control" *ngIf="addressesInfo.physicalAddress.readOnly &amp;&amp; settableAddressesMap &amp;&amp; settableAddressesMap[site.physicalAddressId]" type="text" [(ngModel)]="settableAddressesMap[site.physicalAddressId].itsmName" name="physicalAddressItsmName" maxlength="100" [disabled]="true">
                  <button class="btn btn-primary float-right" [hidden]="addressesInfo.physicalAddress.readOnly" type="button" (click)="selectAddress(addressesInfo.physicalAddress.name)">Search / Add</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row" *ngIf="site.physicalAddressId &amp;&amp; settableAddressesMap &amp;&amp; settableAddressesMap[site.physicalAddressId]">
              <div class="col-sm-12 mt-4" [hidden]="!settableAddressesMap[site.physicalAddressId].businessPartnerId"><span [ngClass]="{row: true, indented: true}">BP ID -<b> &nbsp;{{ settableAddressesMap[site.physicalAddressId].businessPartnerId }}</b></span></div>
              <div class="col-sm-12" [hidden]="!settableAddressesMap[site.physicalAddressId].itsmSiteName"><span [ngClass]="{row: true, indented: true}">SITE -<b> &nbsp;{{ settableAddressesMap[site.physicalAddressId].itsmSiteName }}</b></span></div>
              <div class="col-sm-12 mb-4" [hidden]="!settableAddressesMap[site.physicalAddressId].itsmBuilding"><span [ngClass]="{row: true, indented: true}">BUILDING -<b> &nbsp;{{ settableAddressesMap[site.physicalAddressId].itsmBuilding }}</b></span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.physicalAddressId].name1 }}</span></div>
              <div class="col-sm-12" [hidden]="!settableAddressesMap[site.physicalAddressId].name2"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.physicalAddressId].name2 }}</span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.physicalAddressId].line1 }}</span></div>
              <div class="col-sm-12" [hidden]="!settableAddressesMap[site.physicalAddressId].line2"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.physicalAddressId].line2 }}</span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">
                  {{ settableAddressesMap[site.physicalAddressId].city }}{{ settableAddressesMap[site.physicalAddressId].region ? ',' : '' }}
                   {{ settableAddressesMap[site.physicalAddressId].region | region }}
                   {{ settableAddressesMap[site.physicalAddressId].postalCode }}</span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.physicalAddressId].country | country }}</span></div>
            </div>
          </div>
        </div>
        <div class="row card-block mt-3 p-0 pt-4 pb-4" *ngIf="!loading">
          <div class="col">
            <div class="row">
              <div class="col-sm-12">
                <div class="col-sm-11">
                  <h4>{{ addressesInfo.serviceAddress.humanReadableTitle }}</h4>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="settableAddresses &amp;&amp; settableAddresses.length">
              <div class="col-sm-12">
                <div class="col-sm-12">
                  <select class="form-control" id="serviceAddress" *ngIf="!addressesInfo.serviceAddress.readOnly" [(ngModel)]="site.serviceAddressId" [name]="&quot;serviceAddressId&quot;" autoLinkToLabel (change)="makeAddressesConsistentWithFlagsHelper()">
                    <option *ngFor="let addr of settableServiceAddresses" [ngValue]="addr.id">{{ addr.itsmName }}</option>
                  </select>
                  <input class="form-control" *ngIf="addressesInfo.serviceAddress.readOnly &amp;&amp; settableAddressesMap &amp;&amp; settableAddressesMap[site.serviceAddressId]" type="text" [(ngModel)]="settableAddressesMap[site.serviceAddressId].itsmName" name="serviceAddressItsmName" maxlength="100" [disabled]="true">
                  <div class="custom-control custom-checkbox w-50 d-inline-block">
                    <input class="custom-control-input" id="serviceSameAsPhysical" type="checkbox" [(ngModel)]="serviceSameAsPhysical" name="serviceSameAsPhysical" (change)="copyValues(addressCopyFlagNames.serviceSameAsPhysical)">
                    <label class="custom-control-label small" for="serviceSameAsPhysical">Same as Physical Address</label>
                  </div><a class="float-right" href="javascript:void(0);" [hidden]="addressesInfo.serviceAddress.readOnly" type="button" (click)="selectAddress(addressesInfo.serviceAddress.name, true)">Search / Add</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row" *ngIf="site.serviceAddressId &amp;&amp; settableAddressesMap &amp;&amp; settableAddressesMap[site.serviceAddressId]">
              <div class="col-sm-12 mt-4" [hidden]="!settableAddressesMap[site.serviceAddressId].itsmSiteName"><span [ngClass]="{row: true, indented: true}">SITE -<b> &nbsp;{{ settableAddressesMap[site.serviceAddressId].itsmSiteName }}</b></span></div>
              <div class="col-sm-12 mb-4" [hidden]="!settableAddressesMap[site.serviceAddressId].itsmBuilding"><span [ngClass]="{row: true, indented: true}">BUILDING -<b> &nbsp;{{ settableAddressesMap[site.serviceAddressId].itsmBuilding }}</b></span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.serviceAddressId].name1 }}</span></div>
              <div class="col-sm-12" [hidden]="!settableAddressesMap[site.serviceAddressId].name2"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.serviceAddressId].name2 }}</span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.serviceAddressId].line1 }}</span></div>
              <div class="col-sm-12" [hidden]="!settableAddressesMap[site.serviceAddressId].line2"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.serviceAddressId].line2 }}</span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">
                  {{ settableAddressesMap[site.serviceAddressId].city }}{{ settableAddressesMap[site.serviceAddressId].region ? ',' : '' }}
                   {{ settableAddressesMap[site.serviceAddressId].region | region }}
                   {{ settableAddressesMap[site.serviceAddressId].postalCode }}</span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.serviceAddressId].country | country }}</span></div>
            </div>
          </div>
        </div>
        <div class="row card-block mt-3 p-0 pt-4 pb-4" *ngIf="!loading">
          <div class="col">
            <div class="row">
              <div class="col-sm-12">
                <div class="col-sm-11">
                  <h4>{{ addressesInfo.consumableAddress.humanReadableTitle }}</h4>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="settableAddresses &amp;&amp; settableAddresses.length">
              <div class="col-sm-12">
                <div class="col-sm-12">
                  <select class="form-control" id="consumableAddress" *ngIf="!addressesInfo.consumableAddress.readOnly" [(ngModel)]="site.tonerAddressId" [name]="&quot;consumableAddressId&quot;" autoLinkToLabel (change)="makeAddressesConsistentWithFlagsHelper()">
                    <option *ngFor="let addr of settableConsumableAddresses" [ngValue]="addr.id">{{ addr.itsmName }}</option>
                  </select>
                  <input class="form-control" *ngIf="addressesInfo.consumableAddress.readOnly &amp;&amp; settableAddressesMap &amp;&amp; settableAddressesMap[site.tonerAddressId]" type="text" [(ngModel)]="settableAddressesMap[site.tonerAddressId].itsmName" name="tonerAddressItsmName" maxlength="100" [disabled]="true">
                  <div class="custom-control custom-checkbox w-50 d-inline-block">
                    <input class="custom-control-input" id="consumableSameAsPhysical" type="checkbox" [(ngModel)]="consumableSameAsPhysical" name="consumableSameAsPhysical" (change)="copyValues(addressCopyFlagNames.consumableSameAsPhysical)">
                    <label class="custom-control-label small" for="consumableSameAsPhysical">Same as Physical Address</label>
                  </div><a class="float-right" href="javascript:void(0);" [hidden]="addressesInfo.consumableAddress.readOnly" type="button" (click)="selectAddress(addressesInfo.consumableAddress.name)">Search / Add</a>
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" id="consumableSameAsService" type="checkbox" [(ngModel)]="consumableSameAsService" name="consumableSameAsService" (change)="copyValues(addressCopyFlagNames.consumableSameAsService)">
                    <label class="custom-control-label small" for="consumableSameAsService">Same as Service Address</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row" *ngIf="site.tonerAddressId &amp;&amp; settableAddressesMap &amp;&amp; settableAddressesMap[site.tonerAddressId]">
              <div class="col-sm-12 mt-4"><span [ngClass]="{row: true, indented: true}">Label 1 -<b>{{ settableAddressesMap[site.tonerAddressId].customShippingLabel1 || defaultCustomShippingLabel1}}
                    <div class="text-secondary" *ngIf="!settableAddressesMap[site.tonerAddressId].customShippingLabel1 &amp;&amp; !defaultCustomShippingLabel1"> none</div></b></span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">Label 2 -<b>{{ settableAddressesMap[site.tonerAddressId].customShippingLabel2 || defaultCustomShippingLabel2}}
                    <div class="text-secondary" *ngIf="!settableAddressesMap[site.tonerAddressId].customShippingLabel2 &amp;&amp; !defaultCustomShippingLabel2"> none</div></b></span></div>
              <div class="col-sm-12" [hidden]="!settableAddressesMap[site.tonerAddressId].itsmSiteName"><span [ngClass]="{row: true, indented: true}">SITE -<b> &nbsp;{{ settableAddressesMap[site.tonerAddressId].itsmSiteName }}</b></span></div>
              <div class="col-sm-12 mb-4" [hidden]="!settableAddressesMap[site.tonerAddressId].itsmBuilding"><span [ngClass]="{row: true, indented: true}">BUILDING -<b>&nbsp;{{ settableAddressesMap[site.tonerAddressId].itsmBuilding }}</b></span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.tonerAddressId].name1 }}</span></div>
              <div class="col-sm-12" [hidden]="!settableAddressesMap[site.tonerAddressId].name2"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.tonerAddressId].name2 }}</span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.tonerAddressId].line1 }}</span></div>
              <div class="col-sm-12" [hidden]="!settableAddressesMap[site.tonerAddressId].line2"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.tonerAddressId].line2 }}</span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">
                  {{ settableAddressesMap[site.tonerAddressId].city }}{{ settableAddressesMap[site.tonerAddressId].region ? ',' : '' }}
                   {{ settableAddressesMap[site.tonerAddressId].region | region }}
                   {{ settableAddressesMap[site.tonerAddressId].postalCode }}</span></div>
              <div class="col-sm-12"><span [ngClass]="{row: true, indented: true}">{{ settableAddressesMap[site.tonerAddressId].country | country }}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-10 card-block" style="padding: 0">
        <div class="row justify-content-center" style="padding: 25px 5px">
          <div class="col-md-12 row">
            <div class="col-md-6">
              <h5 class="column-title" id="card-title">Additional Dates<i>(optional)</i></h5>
            </div>
            <div class="col-md-6 text-right"><a (click)="onDateFormClose()" href="javascript:void(0)"><span class="rotate180 icon oi oi-chevron-bottom" [class.open]="collapseDates"></span></a></div>
          </div>
        </div>
        <div class="soft-underline" *ngIf="collapseDates"></div>
        <div class="row justify-content-md-center" id="card-content" [style.display]="collapseDates? &quot;flex&quot;: &quot;none&quot;">
          <div class="col-lg-6" style="padding:0 20px">
            <div class="title-container sticky-top" style="background-color: white;text-align: center;padding-top: 15px;">
              <h5 class="column-title">ESTIMATED DATES</h5>
            </div>
            <div class="form-group form-date" id="estimated1">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedStartDate">Deployment delivery start</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Estimated Start Date" helpString="The estimated date that deployment deliverables will begin for this site"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedStartDateDatePicker" [(ngModel)]="site.estimatedStartDate" [value]="site.estimatedStartDate" showInputOnly="estimatedStartDate" name="estimatedStartDateDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated2">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedCompleteDate">Deployment delivery completion</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Estimated Start Date" helpString="The estimated date that deployment deliverables will begin for this site"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedCompleteDateDateDatePicker" [(ngModel)]="site.estimatedCompleteDate" [value]="site.estimatedCompleteDate" showInputOnly="estimatedCompleteDate" name="estimatedCompleteDateDateDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated3">
              <div class="row">
                <label class="col-md-8 text-muted font-weight-lighter font-italic">Site Design Customer Approval</label>
                <label class="col-md-4 text-muted font-weight-lighter font-italic" style="padding-left: 0px;">N/A</label>
              </div>
            </div>
            <div class="form-group form-date" id="estimated4">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="hardwareOrderDate">Hardware Order Submission</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Hardware Order Submission" helpString="The equipment order should be submitted for processing by this date"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="hardwareOrderDateDateDatePicker" [(ngModel)]="site.hardwareOrderDate" showInputOnly="hardwareOrderDate" name="hardwareOrderDateDateDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated6">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="installDate">Installation</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Installation" helpString="The scheduled installation date"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="installDateDateDatePicker" [(ngModel)]="site.installDate" showInputOnly="installDate" name="installDateDateDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated7">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="submissionDate">Post Installation Data Submission</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Post Installation Data Submission" helpString="The date devices are submitted to the Usage Service database post installation"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="submissionDateDatePicker" [(ngModel)]="site.submissionDate" showInputOnly="submissionDate" name="submissionDateDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated8" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedSiteSowSigned">Site SOW Signed</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Site SOW Signed" helpString="Site SOW Signed (Estimated)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedSiteSowSignedDatePicker" [(ngModel)]="site.estimatedSiteSowSigned" showInputOnly="estimatedSiteSowSigned" name="estimatedSiteSowSignedDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated9" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedSiteDiscovery">Site Discovery</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Site Discovery" helpString="Site Discovery (Estimated)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedSiteDiscoveryDatePicker" [(ngModel)]="site.estimatedSiteDiscovery" showInputOnly="estimatedSiteDiscovery" name="estimatedSiteDiscoveryDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated10" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedSiteDesignApproval">Site Design Approved</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Site Design Approved" helpString="Site Design Approved (Estimated)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedSiteDesignApprovalDatePicker" [(ngModel)]="site.estimatedSiteDesignApproval" showInputOnly="estimatedSiteDesignApproval" name="estimatedSiteDesignApprovalDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated11" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedSiteMonitoringEnabled">Enable Device Collection</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Enable Device Collection" helpString="Device Collection Enabled (Estimated)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedSiteMonitoringEnabledDatePicker" [(ngModel)]="site.estimatedSiteMonitoringEnabled" showInputOnly="estimatedSiteMonitoringEnabled" name="estimatedSiteMonitoringEnabledDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated12" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedSiteReadyToDeploy">Ready to Deploy</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Ready to Deploy" helpString="Ready to Deploy (Estimated)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedSiteReadyToDeployDatePicker" [(ngModel)]="site.estimatedSiteReadyToDeploy" showInputOnly="estimatedSiteReadyToDeploy" name="estimatedSiteReadyToDeployDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated13" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedSiteDeploymentStart">Deployment Start</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Deployment Start" helpString="Deployment Start (Estimated)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedSiteDeploymentStartDatePicker" [(ngModel)]="site.estimatedSiteDeploymentStart" showInputOnly="estimatedSiteDeploymentStart" name="estimatedSiteDeploymentStartDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated14" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedSiteDeploymentEnd">Deployment End</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Deployment End" helpString="Deployment End (Estimated)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedSiteDeploymentEndDatePicker" [(ngModel)]="site.estimatedSiteDeploymentEnd" showInputOnly="estimatedSiteDeploymentEnd" name="estimatedSiteDeploymentEndDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated15" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedSiteCustomerAcceptance">Customer Acceptance</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Customer Acceptance" helpString="Customer Acceptance (Estimated)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedSiteCustomerAcceptanceDatePicker" [(ngModel)]="site.estimatedSiteCustomerAcceptance" showInputOnly="estimatedSiteCustomerAcceptance" name="estimatedSiteCustomerAcceptanceDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated16" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="estimatedSiteHandover">Site Handover Completion</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Site Handover Completion" helpString="Site Handover Date"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="estimatedSiteHandoverDatePicker" [(ngModel)]="site.estimatedSiteHandover" showInputOnly="estimatedSiteHandover" name="estimatedSiteHandoverDatePicker"></datepicker>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 bg-soft-blue" style="padding:0 20px">
            <div class="title-container sticky-top" style="background-color: #F2FAFD;text-align: center;padding-top: 15px;">
              <h5 class="column-title">ACTUAL DATES</h5>
            </div>
            <div class="form-group form-date" id="estimated1">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="startDate">Deployment delivery start</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Estimated Start Date" helpString="The estimated date that deployment deliverables will begin for this site"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="startDateDatePicker" [(ngModel)]="site.startDate" [value]="site.startDate" showInputOnly="startDate" name="startDateDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated2">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="completeDate">Deployment delivery completion</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Deployment delivery completion" helpString="The actual completion date that all deployment deliverables have been completed for this site"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="completionDateDateDatePicker" [(ngModel)]="site.completionDate" [value]="site.completionDate" showInputOnly="completionDate" name="completionDateDateDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated3">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualDesignCustomerApproval">Site Design Customer Approval</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Site Design Customer Approval" helpString="Site Design Customer Approval"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualDesignCustomerApprovalDatePicker" [(ngModel)]="site.actualDesignCustomerApproval" showInputOnly="actualDesignCustomerApproval" name="actualDesignCustomerApprovalDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated4">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualHardwareOrderDate">Hardware Order Submission</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Hardware Order Submission" helpString="The equipment order should be submitted for processing by this date"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualHardwareOrderDateDatePicker" [(ngModel)]="site.actualHardwareOrderDate" showInputOnly="actualHardwareOrderDate" name="actualHardwareOrderDateDateDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated6">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label class="text-muted font-weight-lighter font-italic">Installation</label>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <input class="muted-input text-muted font-weight-lighter font-italic" type="text" disabled [value]="site.installDate" style="width: 100%;">
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated7">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSubmissionDate">Post Installation Data Submission</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Post Installation Data Submission" helpString="The date devices are submitted to the Usage Service database post installation"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSubmissionDateDateDatePicker" [(ngModel)]="site.actualSubmissionDate" showInputOnly="actualSubmissionDate" name="actualSubmissionDateDateDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated8" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSiteSowSigned">Site SOW Signed</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Site SOW Signed" helpString="Site SOW Signed (Actual)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSiteSowSignedDatePicker" [(ngModel)]="site.actualSiteSowSigned" showInputOnly="actualSiteSowSigned" name="actualSiteSowSignedDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated9" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSiteDiscovery">Site Discovery</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Site Discovery" helpString="Site Discovery (Actual)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSiteDiscoveryDatePicker" [(ngModel)]="site.actualSiteDiscovery" showInputOnly="actualSiteDiscovery" name="actualSiteDiscoveryDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated10" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSiteDesignApproval">Site Design Approved</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Site Design Approved" helpString="Site Design Approved (Actual)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSiteDesignApprovalDatePicker" [(ngModel)]="site.actualSiteDesignApproval" showInputOnly="actualSiteDesignApproval" name="actualSiteDesignApprovalDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated11" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSiteMonitoringEnabled">Enable Device Collection</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Enable Device Collection" helpString="Device Collection Enabled (Actual)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSiteMonitoringEnabledDatePicker" [(ngModel)]="site.actualSiteMonitoringEnabled" showInputOnly="actualSiteMonitoringEnabled" name="actualSiteMonitoringEnabledDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated12" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSiteReadyToDeploy">Ready to Deploy</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Ready to Deploy" helpString="Ready to Deploy (Actual)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSiteReadyToDeployDatePicker" [(ngModel)]="site.actualSiteReadyToDeploy" showInputOnly="actualSiteReadyToDeploy" name="actualSiteReadyToDeployDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated13" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSiteDeploymentStart">Deployment Start</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Deployment Start" helpString="Deployment Start (Actual)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSiteDeploymentStartDatePicker" [(ngModel)]="site.actualSiteDeploymentStart" showInputOnly="actualSiteDeploymentStart" name="actualSiteDeploymentStartDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated14" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSiteDeploymentEnd">Deployment End</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Deployment End" helpString="Deployment End (Actual)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSiteDeploymentEndDatePicker" [(ngModel)]="site.actualSiteDeploymentEnd" showInputOnly="actualSiteDeploymentEnd" name="actualSiteDeploymentEndDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated15" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSiteCustomerAcceptance">Customer Acceptance</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Customer Acceptance" helpString="Customer Acceptance (Actual)"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSiteCustomerAcceptanceDatePicker" [(ngModel)]="site.actualSiteCustomerAcceptance" showInputOnly="actualSiteCustomerAcceptance" name="actualSiteCustomerAcceptanceDatePicker"></datepicker>
                </div>
              </div>
            </div>
            <div class="form-group form-date" id="estimated16" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="row">
                <div class="form-group col-lg-8" style="display: inline-block; top: 5px;padding-right: 0px;">
                  <label for="actualSiteHandover">Site Handover Completion</label>
                  <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="Site Handover Completion" helpString="Site Handover Date"></help-dialog-button>
                </div>
                <div class="form-group col-lg-4" style="padding-left: 0px;">
                  <datepicker class="right input-group-append" id="actualSiteHandoverDatePicker" [(ngModel)]="site.actualSiteHandover" showInputOnly="actualSiteHandover" name="actualSiteHandover"></datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-10 card-block">
        <div class="m-2">
          <div class="row mb-3">
            <div class="col-12">
              <h5 class="float-left column-title">Contacts<i> (Contacts are not saved until 'Save and continue' is pressed on the Workflow)</i></h5>
            </div>
          </div>
          <table class="table table-responsive customer-table">
            <thead>
              <tr class="table-header-with-controls">
                <th class="actions" style="width: 220px;">Type</th>
                <th>Select Email Address</th>
                <th style="width: 180px;">Name</th>
                <th style="width: 100px;"> BP ID</th>
                <th style="width: 100px;">Actions</th>
              </tr>
            </thead>
            <tbody *ngIf="itsmSiteContactsMap &amp;&amp; site">
              <ng-container *ngFor="let c of contactTypes">
                <tr>
                  <td style="width: 220px;">
                    <label [ngClass]="{required: c.name === &quot;Consumable Contact&quot; || c.name === &quot;Service Delivery Contact&quot; || (requireContactForOrderStatus1 &amp;&amp; c.name === &quot;Order Status 1 Contact&quot;)}">{{c.name}}</label>
                    <help-dialog-button class="btn-offset" style="padding-right: 15px; float: right; padding-top: 0px;" fieldName="{{c.name}}" helpString="{{c.helpString}}"></help-dialog-button>
                  </td>
                  <td>
                    <select class="form-control" [(ngModel)]="site[c.identifier]" [id]="c.identifier" [name]="c.identifier" autoLinkToLabel>
                      <option [ngValue]="null"></option>
                      <option *ngFor="let ct of itsmSiteContacts" [ngValue]="ct.id">{{ ct.firstName }}, {{ ct.lastName }} ( {{ ct.emailAddress }} )</option>
                    </select><span class="d-block" *ngIf="site[c.identifier] &amp;&amp; (!itsmSiteContactsMap[site[c.identifier]] || !itsmSiteContactsMap[site[c.identifier]].itsmContactId)" style="color: red;">INVALID contact</span>
                  </td>
                  <td>{{ site[c.identifier] && itsmSiteContactsMap[site[c.identifier]] && itsmSiteContactsMap[site[c.identifier]].name }}</td>
                  <td>{{ site[c.identifier] && itsmSiteContactsMap[site[c.identifier]] && itsmSiteContactsMap[site[c.identifier]].businessPartnerId }}</td>
                  <td class="text-center" style="width: 100px;"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Search / Add Contact" (click)="selectContact(site[c.identifier], c.field)">Search/Add</a></td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col mb-2 ml-4 d-flex align-items-end justify-content-end">
            <div class="btn-group mr-2">
              <button class="btn btn-outline-primary" type="button" (click)="download()"><span class="oi oi-cloud-download"></span> Export Contacts</button>
            </div>
            <div class="btn-group"><a class="btn btn-outline-primary" [uploadFileTo]="'/api/sites/import-contacts?siteId=' + site.id" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" (closed)="importContactsClosed($event)"><span class="oi oi-cloud-upload"></span> Import Contacts</a></div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="col-md-10 card-block">
        <div class="m-2">
          <div class="row mb-10">
            <div class="col-12">
              <h5 class="float-left column-title"> Contractual Contacts
                <button class="btn btn-primary ml-1" *ngIf="isContactRefresh" title="Click to refresh contractual contacts" type="button" style="font-size:10.5px;" (click)="syncContractualContacts()"><span class="icon oi oi-reload" [ngClass]="{'icn-spinner': spinRefreshContactButton}" style="margin-right: 2px;font-size: 10px;"></span></button>
              </h5>
            </div>
          </div><i> (Contractual Contacts are not saved until 'Save and continue' is pressed on the Workflow)</i>
          <table class="table table-responsive customer-table">
            <thead>
              <tr class="table-header-with-controls">
                <th class="actions" style="width: 220px;">Type</th>
                <th>Select Email Address</th>
                <th style="width: 180px;">Name</th>
                <th style="width: 100px;"> BP ID</th>
                <th style="width: 100px;"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let c of contactHumanReadableNames">
                <tr></tr>
                <td class="required-add-asterisk">{{c.name}}</td>
                <td>
                  <select class="form-control" [(ngModel)]="site[c.identifier]" [id]="c.identifier" [name]="c.identifier" autoLinkToLabel>
                    <option *ngFor="let ct of ContractualContactTypes[c.type]" [ngValue]="ct.id"> {{ ct.emailAddress }}</option>
                  </select><span class="d-block" *ngIf="site[c.identifier] &amp;&amp; (!itsmContactsWithBpIdMap[site[c.identifier]] || !itsmContactsWithBpIdMap[site[c.identifier]].itsmContactId)" style="color: red;">INVALID contact</span>
                </td>
                <td>{{ site[c.identifier] && itsmContactsWithBpIdMap[site[c.identifier]] && itsmContactsWithBpIdMap[site[c.identifier]].name }}</td>
                <td>{{ site[c.identifier] && itsmContactsWithBpIdMap[site[c.identifier]] && itsmContactsWithBpIdMap[site[c.identifier]].businessPartnerId }}</td>
                <td class="text-center" style="width: 100px;"></td>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</div>